/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Workspace = {
    /**
     * ID of the workspace
     */
    id: string;
    ownerId: string;
    createdBy: string;
    lastEditedBy: string;
    slug: string;
    domain: string | null;
    name: string;
    created: string;
    updated: string;
    _object: Workspace._object;
};
export namespace Workspace {
    export enum _object {
        WORKSPACE = 'workspace',
    }
}

